import type { SavedLayoutDocument, TableLayoutOffset } from './layout-types.js';

const STORAGE_KEY = 'cl-vivo-layout-editor-v1';

export function loadLayoutDocument(): SavedLayoutDocument | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const doc = JSON.parse(raw) as SavedLayoutDocument;
    if (doc.version !== 1) return null;
    return doc;
  } catch {
    return null;
  }
}

export function saveLayoutDocument(offsets: TableLayoutOffset[], decor: SavedLayoutDocument['decor']): SavedLayoutDocument {
  const doc: SavedLayoutDocument = {
    version: 1,
    savedAt: new Date().toISOString(),
    offsets,
    decor,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(doc));
  return doc;
}
